import { SpecialDemand } from '../calculators/special-demand-ids'
import { MatrixDemand } from '../components/system-container/energy-system/UsageMatrixConnectionCell'
import {
  DemandFragment,
  DemandType,
  HourSeriesFragment,
} from '../generated/graphql'
import { Language } from '../i18n'

/** Sort demands to ensure they are matched correctly with form input */
export const getSortedHeatingDemands = (
  demands: DemandFragment[],
): DemandFragment[] =>
  demands
    .filter((demand) => demand.type === DemandType.Heating)
    .sort((a, b) =>
      a.hourSeries.name.localeCompare(b.hourSeries.name, Language.Finnish),
    )

export type DemandForSorting = Pick<DemandFragment, 'id' | 'type'> & {
  hourSeries: Pick<HourSeriesFragment, 'name'>
}

export function sortMatrixDemands(a: MatrixDemand, b: MatrixDemand): number {
  if (a.id === SpecialDemand.OtherProvidersElectricity) {
    return 1
  }
  if (b.id === SpecialDemand.OtherProvidersElectricity) {
    return -1
  }

  return a.name.localeCompare(b.name, Language.Finnish)
}
